import React from "react";

function AOV() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="30"
      height="30"
      enableBackground="new 0 0 512 512"
      viewBox="0 0 512 512"
    >
      <path
        fill="#828282"
        d="M157.99 338.02c-1.56 0-3.12-.61-4.3-1.82l-47.87-49.34a5.979 5.979 0 01.13-8.47 5.985 5.985 0 018.46.13l47.88 49.35a5.985 5.985 0 01-4.3 10.15zm29.11 9.02c-1.26 0-2.53-.39-3.61-1.22-2.64-1.99-3.15-5.75-1.16-8.38l52.99-69.89c2-2.64 5.76-3.15 8.39-1.16 2.64 2 3.15 5.76 1.16 8.39l-52.99 69.89a5.998 5.998 0 01-4.78 2.37zm159.67-31.23a6.01 6.01 0 01-3.14-.89l-74.22-45.84c-2.81-1.74-3.69-5.43-1.95-8.24s5.43-3.69 8.24-1.95l74.22 45.84c2.81 1.74 3.69 5.43 1.95 8.24a5.983 5.983 0 01-5.1 2.84z"
        data-original="#828282"
      ></path>
      <path
        fill="#b7d341"
        d="M416.27 257.44h-.12c-21.61-.15-42.59-.5-48.51-.6-28.71-.5-39.84-15.21-44.11-27.46-6.09-17.42-2.8-42.02 9.23-69.29 10.93-24.74 27.59-47.88 44.58-61.87 1.98-1.64 4.92-1.35 6.56.63 1.3 1.58 46.28 2.75 63.79 3.99-.3-1.36 0-2.83.96-3.99a4.662 4.662 0 016.56-.63c16.98 14 33.64 37.13 44.57 61.87 12.04 27.27 15.32 51.88 9.24 69.29-4.28 12.25-15.41 26.96-44.12 27.46-12.21.21-31.38.48-48.59.6h-.04zM383.3 75.73c-2.05 0-3.94-1.37-4.5-3.46L364.48 18.8a4.656 4.656 0 014.5-5.87c5.55 0 10.21 3.66 14.71 7.21 3.1 2.44 6.61 5.2 8.94 5.2 2.32 0 5.84-2.76 8.94-5.2 4.5-3.55 9.15-7.21 14.7-7.21 5.56 0 10.21 3.66 14.71 7.21 3.1 2.44 6.61 5.2 8.94 5.2s5.84-2.76 8.94-5.2c4.5-3.55 9.15-7.21 14.71-7.21a4.7 4.7 0 013.7 1.82c.88 1.15 1.18 2.65.8 4.05l-14.33 53.47a4.66 4.66 0 01-5.71 3.3c-2.48-.67-3.96 5.2-3.29 2.71l.92-3.46h-58.78l.93 3.46c.67 2.49-.81-3.37-3.3-2.71-.4.11-.81.16-1.21.16z"
        data-original="#febb50"
      ></path>
      <path
        fill="#c6701a"
        d="M453.18 106.48h-73.82c-11.04 0-20.03-8.99-20.03-20.04s8.99-20.04 20.03-20.04h73.82c11.05 0 20.03 8.99 20.03 20.04s-8.99 20.04-20.03 20.04z"
        data-original="#c6701a"
      ></path>
      <path
        fill="#fff"
        d="M416.27 217.1c-15.16 0-27.5-9.97-27.5-22.23 0-2.58 2.08-4.66 4.66-4.66 2.57 0 4.66 2.08 4.66 4.66 0 7 8.33 12.91 18.18 12.91 9.86 0 18.18-5.91 18.18-12.91s-8.32-12.91-18.18-12.91c-15.16 0-27.5-9.97-27.5-22.23s12.33-22.23 27.5-22.23 27.5 9.97 27.5 22.23c0 2.57-2.08 4.66-4.66 4.66-2.57 0-4.66-2.09-4.66-4.66 0-7-8.32-12.91-18.18-12.91-9.85 0-18.18 5.91-18.18 12.91 0 6.99 8.33 12.91 18.18 12.91 15.17 0 27.5 9.97 27.5 22.23s-12.33 22.23-27.5 22.23z"
        data-original="#ffffff"
      ></path>
      <path
        fill="#fff"
        d="M416.27 227.65c-2.57 0-4.66-2.09-4.66-4.66v-91.38c0-2.57 2.09-4.66 4.66-4.66s4.66 2.09 4.66 4.66v91.38c0 2.57-2.09 4.66-4.66 4.66z"
        data-original="#ffffff"
      ></path>
      <path
        fill="#fc5248"
        d="M167.92 379.28c-15.33 0-27.81-12.47-27.81-27.81 0-15.33 12.48-27.81 27.81-27.81 15.34 0 27.82 12.48 27.82 27.81-.01 15.34-12.48 27.81-27.82 27.81z"
        data-original="#fc5248"
      ></path>
      <path
        fill="#1aa1ff"
        d="M253.27 281.58c-15.34 0-27.81-12.48-27.81-27.81 0-15.34 12.47-27.81 27.81-27.81 15.33 0 27.81 12.47 27.81 27.81 0 15.33-12.48 27.81-27.81 27.81z"
        data-original="#1aa1ff"
      ></path>
      <path
        fill="#fc5248"
        d="M365.36 349.09c-15.34 0-27.81-12.48-27.81-27.81 0-15.34 12.47-27.81 27.81-27.81 15.33 0 27.81 12.47 27.81 27.81 0 15.33-12.48 27.81-27.81 27.81z"
        data-original="#fc5248"
      ></path>
      <path
        fill="#55d47b"
        d="M98.86 291.8c-15.33 0-27.81-12.48-27.81-27.81 0-15.34 12.48-27.81 27.81-27.81 15.34 0 27.81 12.47 27.81 27.81 0 15.33-12.47 27.81-27.81 27.81z"
        data-original="#55d47b"
      ></path>
      <path
        fill="#646464"
        d="M20.89 484.17h-.16l-.15-.01h-.16l-.15-.02-.15-.02-.15-.02-.14-.02-.15-.03-.15-.03-.14-.04-.14-.03-.14-.04h-.01l-.13-.05-.14-.05-.14-.05-.13-.06h-.01l-.13-.06-.13-.06-.13-.06-.13-.07-.12-.07h-.01l-.12-.07-.12-.08-.12-.08-.12-.08-.12-.09-.11-.08-.11-.09-.11-.1-.11-.09-.11-.1-.1-.1-.1-.1-.1-.11-.09-.11-.09-.11-.09-.11h-.01l-.08-.11-.09-.12-.08-.12-.08-.12-.08-.12-.07-.13-.07-.12-.07-.13-.06-.13-.06-.13-.06-.13-.06-.14-.05-.14-.05-.13-.04-.15-.05-.14-.03-.14-.04-.14-.03-.15-.03-.15-.02-.14-.02-.15-.02-.15-.01-.15-.01-.16-.01-.15V82.52a5.986 5.986 0 0111.97 0V472.2h401.32a5.986 5.986 0 110 11.97H20.89z"
        data-original="#646464"
      ></path>
      <path
        fill="#828282"
        d="M35.78 153.19H5.99c-3.31 0-5.99-2.68-5.99-5.99s2.68-5.99 5.99-5.99h29.79c3.31 0 5.99 2.68 5.99 5.99s-2.68 5.99-5.99 5.99zm321.91 345.88c-3.3 0-5.98-2.68-5.98-5.99v-29.79a5.986 5.986 0 1111.97 0v29.79c0 3.31-2.68 5.99-5.99 5.99zm-88.77 0c-3.3 0-5.98-2.68-5.98-5.99v-29.79a5.986 5.986 0 1111.97 0v29.79c0 3.31-2.68 5.99-5.99 5.99zm-88.77 0c-3.3 0-5.98-2.68-5.98-5.99v-29.79a5.986 5.986 0 1111.97 0v29.79c0 3.31-2.68 5.99-5.99 5.99zm-88.77 0c-3.3 0-5.98-2.68-5.98-5.99v-29.79a5.986 5.986 0 1111.97 0v29.79c0 3.31-2.68 5.99-5.99 5.99zm-55.6-79.57H5.99c-3.31 0-5.99-2.68-5.99-5.99s2.68-5.99 5.99-5.99h29.79c3.31 0 5.99 2.68 5.99 5.99s-2.68 5.99-5.99 5.99zm0-88.77H5.99c-3.31 0-5.99-2.68-5.99-5.99s2.68-5.99 5.99-5.99h29.79c3.31 0 5.99 2.68 5.99 5.99s-2.68 5.99-5.99 5.99zm0-88.77H5.99c-3.31 0-5.99-2.68-5.99-5.99s2.68-5.99 5.99-5.99h29.79c3.31 0 5.99 2.68 5.99 5.99s-2.68 5.99-5.99 5.99z"
        data-original="#828282"
      ></path>
      <path
        fill="#fc5248"
        d="M134.03 221.18a5.989 5.989 0 01-5.96-5.45c-3.58-39.62 15.02-76.87 53.76-107.73 24.29-19.34 50.25-31.17 60.88-35.58l-4.28-24.18a5.98 5.98 0 012.67-6.09 5.985 5.985 0 016.65.14l71.09 49.68a5.985 5.985 0 011.48 8.34l-49.68 71.09a5.978 5.978 0 01-6.2 2.42 5.986 5.986 0 01-4.6-4.8l-4.14-23.37c-71.38 15.46-116.48 72.63-116.94 73.22a5.992 5.992 0 01-4.73 2.31z"
        data-original="#fc5248"
      ></path>
    </svg>
  );
}

export default AOV;
